import { GuidePages } from '../pages/GuidePages/GuidePages';
import { StripperPages } from '../pages/StripperPages/StripperPages';
import { ServiceProviderPages } from '../pages/ServiceProviderPages/ServiceProviderPages';
import {SalesPartnerPages} from "../pages/SalesPartnerPages/SalesPartnerPages";

export const PAGES = {
  GUIDE: GuidePages,
  EVENT_STAFF: StripperPages,
  BOOKING_MANAGER: ServiceProviderPages,
  SALES_PARTNER: SalesPartnerPages,
};